import { render, staticRenderFns } from "./course-details.vue?vue&type=template&id=ae5ecfb4&scoped=true"
import script from "./course-details.vue?vue&type=script&lang=js"
export * from "./course-details.vue?vue&type=script&lang=js"
import style0 from "./course-details.vue?vue&type=style&index=0&id=ae5ecfb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5ecfb4",
  null
  
)

export default component.exports